import type { AccountTab } from './utils/accountRedirect';

type Translate = (key: string) => string;

const VERIFICATION_API_FRAGMENT = 'must be verified';

export function isAccountActionMessage(message: string, t: Translate): boolean {
  if (!message) return false;
  return (
    message === t('verification.rent_blocked') ||
    message === t('verification.add_blocked') ||
    message === t('manage.connect_required') ||
    message.toLowerCase().includes(VERIFICATION_API_FRAGMENT)
  );
}

/** Which account tab resolves the blocking issue described by the message. */
export function accountTabForMessage(message: string, t: Translate): AccountTab {
  return message === t('manage.connect_required') ? 'owner' : 'settings';
}

export function isVerificationRequiredApiError(err: unknown): boolean {
  if (typeof err !== 'object' || err === null || !('response' in err)) return false;
  const response = (err as { response?: { status?: number; data?: unknown } }).response;
  if (response?.status !== 403) return false;
  const data = response.data;
  if (typeof data === 'string') {
    return data.toLowerCase().includes(VERIFICATION_API_FRAGMENT);
  }
  return false;
}
